/**
 * ConfiguracionPage — Página de configuración del módulo Centro de Ayuda.
 * Contiene 3 tabs: Prioridades | Clasificación | Canales.
 *
 * Las configuraciones de Correos y Almacenamiento siguen en la página Empresa
 * (sección "Configuración del Centro de Ayuda"), porque son parte del perfil
 * de la empresa-tenant.
 */
import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { AlertTriangle, FlagTriangleRight, FolderTree, Inbox, Headset, ShieldCheck } from 'lucide-react';
import PrioridadesTab from './tabs/PrioridadesTab';
import ClasificacionTab from './tabs/ClasificacionTab';
import CanalesTab from './tabs/CanalesTab';
import HealthcheckPanel from './components/HealthcheckPanel';
import { useAuth } from '../../context/AuthContext';

export default function ConfiguracionPage() {
  const { empresa, api, user } = useAuth();
  const [tab, setTab] = useState('prioridades');
  const isAdmin = ['ADMINISTRADOR', 'SUPERADMIN'].includes(user?.rol);

  if (!empresa?.modulo_tickets_activo) {
    return (
      <div className="container mx-auto py-8 max-w-3xl">
        <Card>
          <CardContent className="py-10 text-center text-slate-500">
            <AlertTriangle className="w-10 h-10 mx-auto mb-3 text-amber-500" />
            <p className="font-medium text-slate-800">El módulo Centro de Ayuda no está activado.</p>
            <p className="text-sm mt-2">Active el módulo desde la página Empresa para acceder a esta configuración.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-6 px-4 max-w-6xl">
      <Card className="border-slate-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-2xl">
            <Headset className="w-6 h-6 text-slate-700" />
            Configuración del Centro de Ayuda
          </CardTitle>
          <CardDescription>
            Gestione los maestros del módulo de tickets: prioridades con SLA, árbol de clasificación
            de 5 niveles y canales de ingreso.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs value={tab} onValueChange={setTab}>
            <TabsList className="grid grid-cols-4 w-full max-w-2xl mb-6">
              <TabsTrigger value="prioridades" data-testid="tab-prioridades">
                <FlagTriangleRight className="w-4 h-4 mr-2" /> Prioridades
              </TabsTrigger>
              <TabsTrigger value="clasificacion" data-testid="tab-clasificacion">
                <FolderTree className="w-4 h-4 mr-2" /> Clasificación
              </TabsTrigger>
              <TabsTrigger value="canales" data-testid="tab-canales">
                <Inbox className="w-4 h-4 mr-2" /> Canales
              </TabsTrigger>
              <TabsTrigger value="healthcheck" data-testid="tab-healthcheck">
                <ShieldCheck className="w-4 h-4 mr-2" /> Healthcheck
              </TabsTrigger>
            </TabsList>

            <TabsContent value="prioridades"><PrioridadesTab api={api} /></TabsContent>
            <TabsContent value="clasificacion"><ClasificacionTab api={api} /></TabsContent>
            <TabsContent value="canales"><CanalesTab api={api} /></TabsContent>
            <TabsContent value="healthcheck"><HealthcheckPanel api={api} isAdmin={isAdmin} /></TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
